var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgView(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.5 12C15.5 13.6569 14.1569 15 12.5 15C10.8432 15 9.5 13.6569 9.5 12C9.5 10.3431 10.8432 9 12.5 9C14.1569 9 15.5 10.3431 15.5 12Z",
    stroke: "#4E465E",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5012 5C8.02354 5 4.23326 7.94288 2.95898 12C4.23324 16.0571 8.02354 19 12.5012 19C16.9788 19 20.7691 16.0571 22.0434 12C20.7691 7.94291 16.9788 5 12.5012 5Z",
    stroke: "#4E465E",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgView);
export default __webpack_public_path__ + "static/media/view.6c138262fbfa3675740cc77864a3f9a4.svg";
export { ForwardRef as ReactComponent };